import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DronePage from './DronePage';

const msp = (state, ownProps) => ({});

const mdp = (dispatch) => ({});

export default withRouter(connect(msp, mdp)(DronePage));